import {
    EmojiEmotions,
    Favorite,
    FavoriteBorder,
    InsertEmoticon,
    RadioButtonChecked,
    RadioButtonUnchecked,
    Star,
    StarBorder,
    ThumbUpAlt,
    ThumbUpOffAlt,
} from '@mui/icons-material';
import { IconType, QuestionType } from './types';

export const typesSupported: Record<string, boolean> = {
    multiple: true,
    only: true,
    linear: true,
    'linear-label': true,
    'list-only': true,
    'validation-reference': true,
};

export const typesIcon: IconType[] = [
    {
        id: 'circle',
        name: 'Circulo',
        icon: (
            <RadioButtonUnchecked
                fontSize="large"
                style={{ fill: '#3366CC' }}
            />
        ),
        icon2: (
            <RadioButtonChecked fontSize="large" style={{ fill: '#3366CC' }} />
        ),
    },
    {
        id: 'star',
        name: 'Estrella',
        icon: <StarBorder fontSize="large" style={{ fill: '#3366CC' }} />,
        icon2: <Star fontSize="large" style={{ fill: '#3366CC' }} />,
    },
    {
        id: 'smile',
        name: 'Sonrisa',
        icon: <InsertEmoticon fontSize="large" style={{ fill: '#3366CC' }} />,
        icon2: <EmojiEmotions fontSize="large" style={{ fill: '#3366CC' }} />,
    },
    {
        id: 'like',
        name: 'Like',
        icon: <ThumbUpOffAlt fontSize="large" style={{ fill: '#3366CC' }} />,
        icon2: <ThumbUpAlt fontSize="large" style={{ fill: '#3366CC' }} />,
    },
    {
        id: 'heart',
        name: 'Corazón',
        icon: <FavoriteBorder fontSize="large" style={{ fill: '#3366CC' }} />,
        icon2: <Favorite fontSize="large" style={{ fill: '#3366CC' }} />,
    },
];

export const typeQuestions: QuestionType[] = [
    {
        id: 'multiple',
        name: 'Múltiple',
    },
    {
        id: 'only',
        name: 'Unica',
    },
    {
        id: 'linear',
        name: 'Lineal',
    },
    {
        id: 'linear-label',
        name: 'Etiquetas Lineal',
    },
    {
        id: 'text',
        name: 'Texto',
    },
    {
        id: 'big-text',
        name: 'Texto Grande',
    },
    {
        id: 'list-only',
        name: 'Lista Desplegable',
    },
    {
        id: 'validation-reference',
        name: 'Validación de Referencia',
    },
    {
        id: 'open-text',
        name: 'Enunciado Abierto',
    },
    { id: 'label', name: 'Informativa' },
];

export const subtypeQuestions: QuestionType[] = [
    {
        id: 'number',
        name: 'Numérico',
    },
    {
        id: 'alphabet',
        name: 'Alfabético',
    },
    {
        id: 'alphanumeric',
        name: 'Alfanumérico',
    },
];
